import { ChangeDetectorRef, Component, OnDestroy, QueryList, ViewChildren } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { MenuItem, MenuItems } from '../../../shared/menu-items/menu-items';
import { DemoMaterialModule } from 'src/app/demo-material-module';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { CommonConfig } from 'src/app/shared/common-config/common-config';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatMenu } from '@angular/material/menu';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports:[DemoMaterialModule, TranslateModule, NgFor, NgIf, RouterModule, CommonModule, MatIconModule],
  templateUrl: './sidebar.component.html',
  styleUrls: []
})
export class AppSidebarComponent implements OnDestroy {
  mobileQuery: MediaQueryList;
  
  private _mobileQueryListener: () => void;
  menuSidebar: Array<MenuItem> = [];
  menuUser: Array<MenuItem> = [];
  
  @ViewChildren(MatMenu) menuessid!: QueryList<MatMenu>;
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    public commonConfig: CommonConfig,
    private translate: TranslateService
  ) {
    this.mobileQuery = media.matchMedia('(min-width:'+commonConfig.getMobileBreakpoint()+'px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addEventListener('resize',this._mobileQueryListener);
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    
    this.menuItems.getOverviewItems().subscribe((menuItems) => {
      this.menuSidebar = menuItems.filter(menu => menu.type !== 'hidden');
    });
    this.menuItems.getUserMenuItems().subscribe((menuItems) => {
      this.menuUser = menuItems.filter(menu => menu.type !== 'hidden');
    });
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener('resize',this._mobileQueryListener);
  }

  getRef(menuitem: MenuItem) {
    if(this.menuessid) {
      const menu = this.menuessid.toArray().find((item: MatMenu) => {
        let m: any = item;
        const nativeElement = m['_elementRef'].nativeElement;
        return nativeElement.id === menuitem.object_id;
      });
      return menu ?? null;
    }
    return null;
  }
}
